var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('PdfAnnotate',{ref:"pdfViewer",attrs:{"toolbar":_vm.toolbar,"src":_vm.pdf}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }